import { useEffect } from "react";

type SeoOptions = {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  jsonLd?: object[];
};

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(blocks: object[]) {
  const containerId = "realtime-jsonld";
  const existing = document.getElementById(containerId);
  if (existing) existing.remove();
  const wrap = document.createElement("div");
  wrap.id = containerId;
  blocks.forEach((block) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(block);
    wrap.appendChild(script);
  });
  document.head.appendChild(wrap);
}

export function useSeo({
  title,
  description,
  keywords = "",
  canonicalPath = "/",
  jsonLd = [],
}: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `https://dcomx.github.io${canonicalPath}`);
    setCanonical(`https://dcomx.github.io${canonicalPath}`);
    if (jsonLd.length > 0) setJsonLd(jsonLd);
    return () => {
      const existing = document.getElementById("realtime-jsonld");
      if (existing) existing.remove();
    };
  }, [title, description, keywords, canonicalPath, jsonLd]);
}